(() => {
  if (window.fanaMobileBuyReady) return;
  window.fanaMobileBuyReady = true;
  let pending = false;
  const text = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  function update() {
    pending = false;
    document.querySelectorAll('[data-bundle-builder]').forEach(builder => {
      let config;
      try { config = JSON.parse(builder.querySelector('[data-bb-config]').textContent); } catch { return; }
      const slots = Array.from(builder.querySelectorAll('.bb-slot'));
      if (!slots.length) return;
      builder.classList.add('fana-compact');
      slots.forEach((slot, index) => {
        const cards = Array.from(slot.querySelectorAll('.bb-card'));
        const rule = config.slots[index];
        if (!rule || !cards.length) return;
        const count = card => { const field = card.querySelector('.bb-stepper__field'); return Number(field?.value || field?.getAttribute('aria-valuenow') || card.querySelector('.bb-stepper__count')?.textContent || 0); };
        const title = card => card.querySelector('.bb-card__title')?.textContent.trim() || '';
        const included = cards.length === 1 && rule.min === 1 && rule.max === 1;
        if (included && count(cards[0]) === 0 && !slot.dataset.fanaIncluded) {
          slot.dataset.fanaIncluded = 'true';
          cards[0].querySelector('.bb-stepper__btn--plus')?.click();
        }
        let pills = slot.querySelector('.fana-pills');
        if (!pills) {
          pills = document.createElement('div');
          pills.className = 'fana-pills';
          pills.setAttribute('role', 'group');
          pills.setAttribute('aria-label', slot.querySelector('h3')?.textContent || '');
          slot.querySelector('.bb-grid').after(pills);
        }
        cards.forEach(card => {
          const name = title(card);
          let pill = Array.from(pills.children).find(element => element.dataset.name === name);
          if (!pill) {
            pill = document.createElement('div');
            pill.className = 'fana-pill';
            pill.dataset.name = name;
            const minus = document.createElement('button');
            minus.type = 'button'; minus.className = 'fana-pill-minus'; minus.textContent = '−';
            minus.setAttribute('aria-label', `Remove one ${name}`);
            const main = document.createElement('button');
            main.type = 'button'; main.className = 'fana-pill-main';
            const currentCard = () => Array.from(slot.querySelectorAll('.bb-card')).find(item => title(item) === name);
            minus.addEventListener('click', () => { currentCard()?.querySelector('.bb-stepper__btn--minus')?.click(); schedule(); });
            main.addEventListener('click', () => {
              if (included) return;
              const current = currentCard();
              if (!current) return;
              if (rule.max === 1) {
                if (count(current)) return;
                slot.querySelectorAll('.bb-card').forEach(item => { if (count(item)) item.querySelector('.bb-stepper__btn--minus')?.click(); });
              }
              currentCard()?.querySelector('.bb-stepper__btn--plus')?.click();
              schedule();
            });
            pill.append(minus, main); pills.append(pill);
          }
          const quantity = count(card);
          const selected = quantity > 0;
          if (pill.dataset.selected !== String(selected)) pill.dataset.selected = String(selected);
          const minus = pill.querySelector('.fana-pill-minus');
          minus.hidden = included || !selected;
          const main = pill.querySelector('.fana-pill-main');
          text(main, included ? `${name} · Included` : `${name}${selected ? ` × ${quantity}` : ''}`);
          const pressed = String(selected);
          if (main.getAttribute('aria-pressed') !== pressed) main.setAttribute('aria-pressed', pressed);
          const plus = card.querySelector('.bb-stepper__btn--plus');
          const total = cards.reduce((sum, item) => sum + count(item), 0);
          const disabled = included || (rule.max > 1 && total >= rule.max) || plus?.disabled === true;
          if (main.disabled !== disabled) main.disabled = disabled;
        });
      });
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  const start = () => {
    const root = document.querySelector('main');
    if (!root) return;
    new MutationObserver(schedule).observe(root, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['aria-valuenow'] });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
